import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Headline } from '@xingternal/typography';

import { SalaryForecastBar } from '../salary-forecast-bar';

export const SalaryNotProvided: React.VFC = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <Headline size="xlarge">
        <FormattedMessage id="JOBS_DETAIL_SALARY_NOT_PROVIDED_HEADLINE" />
      </Headline>
      <SalaryForecastBar
        headlineCopy={formatMessage({ id: 'JOBS_DETAIL_SALARY_NOT_PROVIDED_FORECAST_HEADLINE' })}
        legendCopies={{
          left: formatMessage({ id: 'SALARY_MODULE_RANGE_MIN' }),
          right: formatMessage({ id: 'SALARY_MODULE_RANGE_MAX' }),
        }}
      />
    </>
  );
};
